import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import logo from '../../images/my_btn_mb_w.png';
import Pagenation from 'components/Pagenation';
import * as fireonApi from '../../apis/FireOnApi';
import { apiWrapper } from 'apis/CommonApi';
import { useAppContext } from 'utils/store';
import { API_HOST } from 'Constants';

//소방 설비 현황
export default function BuildingEquipmentStatusComponent(props) {
    let { id } = useParams();
    const [manageId, setManageId] = useState(null);
    const itemsPerPage = 100;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkedIds, setCheckedIds] = useState([]);
    const [dataSource, setDataSource] = useState(null);
    const [previous, setPrevious] = useState(null);
    const [next, setNext] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        getData(1);
    }, []);

    const getData = (page, url = null) => {
        apiWrapper(async () => {
            let result;
            if (url !== null) {
                result = await fireonApi.getFireFightingFacilityListByUrl(url);
            } else {
                result = await fireonApi.getFireFightingFacilityList(id, page, itemsPerPage);
            }

            const { status, data } = result;
            if (status === true) {
                setDataSource(data);

                setPrevious(data.previous);
                setNext(data.next);
                setPage(page);
            } else {
                alert(`${data}`);
            }

        })
    }

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            setCheckedIds(dataSource.results.map((a) => a.id));
        } else {
            setCheckedIds([]);
        }
    };

    const handleChangeChecked = (e, id) => {
        if (e.target.checked) {
            setCheckedIds([...checkedIds, id]);
        } else {
            setCheckedIds(checkedIds.filter((a) => a !== id));
        }
    }

    const openModal = (manageId) => {
        setManageId(manageId);

        setIsModalOpen(true);
        setTimeout(() => {
            const modalContent = document.querySelector(".modal_content");
            if (modalContent) {
                modalContent.style.transform = "translateX(0)";
            }
        }, 10);
    }

    const closeModal = () => {
        const modalContent = document.querySelector(".modal_content");
        if (modalContent) {
            modalContent.style.transform = "translateX(100%)";
        }
        setTimeout(() => {
            setIsModalOpen(false);
        }, 500);
    };

    const handleDelete = () => {
        if (window.confirm("삭제하시겠습니까?")) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.bulkDeleteFireFightingFacility(checkedIds);
                alert(`${data}`)

                //삭제 성공 시 새로고침
                if (status === true) {
                    setCheckedIds([]);
                    getData();
                }
            });
        }
    }

    return (
        <>
            <div className="viewBoard fireOnBoard tableBoard BEStableBoard">
                {checkedIds.length > 0 && (
                    <div className="toolbar" style={{ display: 'block' }}>
                        <div className="wrap_inner">
                            <button className="btn_tb btn_tbAdd" onClick={handleDelete}>선택 삭제</button>
                        </div>
                    </div>
                )}

                <TopBoard header={props.header} />
                <MidColumnBoard openModal={openModal} />
                <TableBoard dataSource={dataSource} openModal={openModal} checkedIds={checkedIds} handleCheckAll={handleCheckAll} handleChangeChecked={handleChangeChecked} />
                {isModalOpen && <Modal manageId={manageId} closeModal={closeModal} getData={getData} />}
            </div >
        </>
    );
}

const Modal = ({ manageId, closeModal, getData }) => {
    const { id } = useParams();
    const [formData, setFormData] = useState(null);
    const isEdit = manageId !== null;

    useEffect(() => {
        setFormDataProperty("category", "");
        setFormDataProperty("name", "");
        setFormDataProperty("approvalNumber", "");
        setFormDataProperty("modelName", "");
        setFormDataProperty("serialNumber", "");
        setFormDataProperty("specifications", "");
        setFormDataProperty("manufacturer", "");
        setFormDataProperty("manufactureDate", "");
        setFormDataProperty("purchaseDate", "");
        setFormDataProperty("purchasePrice", "");
        setFormDataProperty("purchaseCompany", "");
        setFormDataProperty("purchaseContact", "");
        setFormDataProperty("asContact", "");
        setFormDataProperty("photoImageFile", null);
        setFormDataProperty("photoImageFileName", "");
        setFormDataProperty("installationDate", "");
        setFormDataProperty("installationFloor", "");
        setFormDataProperty("detailedLocation", "");
        setFormDataProperty("installationCompany", "");
        setFormDataProperty("installationContact", "");
        setFormDataProperty("operationalStatus", "");

        if (isEdit) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.getFireFightingFacilityById(manageId);
                if (status === true) {
                    setFormDataProperty("category", data.category);
                    setFormDataProperty("name", data.name);
                    setFormDataProperty("approvalNumber", data.approvalNumber);
                    setFormDataProperty("modelName", data.modelName);
                    setFormDataProperty("serialNumber", data.serialNumber);
                    setFormDataProperty("specifications", data.specifications);
                    setFormDataProperty("manufacturer", data.manufacturer);
                    setFormDataProperty("manufactureDate", data.manufactureDate);
                    setFormDataProperty("purchaseDate", data.purchaseDate);
                    setFormDataProperty("purchasePrice", data.purchasePrice);
                    setFormDataProperty("purchaseCompany", data.purchaseCompany);
                    setFormDataProperty("purchaseContact", data.purchaseContact);
                    setFormDataProperty("asContact", data.asContact);
                    setFormDataProperty("photoImageFileName", data.photoImageFileName);
                    setFormDataProperty("installationDate", data.installationDate);
                    setFormDataProperty("installationFloor", data.installationFloor);
                    setFormDataProperty("detailedLocation", data.detailedLocation);
                    setFormDataProperty("installationCompany", data.installationCompany);
                    setFormDataProperty("installationContact", data.installationContact);
                    setFormDataProperty("operationalStatus", data.operationalStatus);

                    //이미지 URL -> Blob 변환
                    try {
                        const response = await fetch(API_HOST + data.photoImage);
                        if (!response.ok) {
                            throw new Error(`${response.status}`);
                        }

                        const blob = await response.blob();
                        const file = new File([blob], data.photoImageFileName, { type: blob.type });
                        setFormDataProperty("photoImageFile", file);
                    } catch (error) {
                        console.error("이미지 URL을 Blob 객체로 변환 실패 : ", error)
                    }
                } else {
                    alert(`${data}`);
                }
            });
        }
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        if (e.target.type === 'file') {
            const newFiles = e.target.files;
            if (newFiles.length > 0) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const image = e.target.result;
                    setFormDataProperty("photoImageFile", newFiles[0]);
                    setFormDataProperty("photoImageFileName", newFiles[0].name);
                };
                reader.readAsDataURL(newFiles[0]);
            }
        } else {
            let name = e.target.name;
            let value = e.target.value;
            setFormDataProperty(name, value);
        }
    };

    const handleSave = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else if (checkValid() === false) {
            e.stopPropagation();
        } else {
            apiWrapper(async () => {
                const requestBody = new FormData();
                requestBody.append("photoImage", formData.photoImageFile);
                requestBody.append("payload",
                    JSON.stringify({
                        category: formData.category,
                        name: formData.name,
                        approvalNumber: formData.approvalNumber,
                        modelName: formData.modelName,
                        serialNumber: formData.serialNumber,
                        specifications: formData.specifications,
                        manufacturer: formData.manufacturer,
                        manufactureDate: formData.manufactureDate,
                        purchaseDate: formData.purchaseDate,
                        purchasePrice: formData.purchasePrice,
                        purchaseCompany: formData.purchaseCompany,
                        purchaseContact: formData.purchaseContact,
                        asContact: formData.asContact,
                        installationDate: formData.installationDate,
                        installationFloor: formData.installationFloor,
                        detailedLocation: formData.detailedLocation,
                        installationCompany: formData.installationCompany,
                        installationContact: formData.installationContact,
                        operationalStatus: formData.operationalStatus
                    }));

                let result;
                if (isEdit) {
                    result = await fireonApi.updateFireFightingFacility(manageId, requestBody);
                } else {
                    result = await fireonApi.createFireFightingFacility(id, requestBody);
                }

                const { status, data } = result;
                alert(`${data}`)

                if (status === true) {
                    //성공 시 새로고침
                    closeModal();
                    getData(1);
                }
            });
        }
    }

    const checkValid = () => {
        if (formData.photoImageFile === null) {
            alert(`CI logo 파일을 선택해주세요.`);
            return false;
        }
        return true;
    }

    const handleDeleteImage = () => {
        setFormDataProperty("photoImageFile", null);
        setFormDataProperty("photoImageFileName", "");
    }

    return (
        <div id="modal" class="modal rightModal darkRightModal noticeRightModal open"
            onClick={(e) => {
                if (e.target === e.currentTarget)
                    closeModal();
            }}>
            <div class="modal_content">
                <button type="button" class="close_modal" onClick={closeModal}>
                    <i class="x-icon close_icon"></i>
                </button>
                <h2>소방 설비 정보</h2>
                {formData && (
                    <form class="wrap_detail_cont type2" onSubmit={handleSave}>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설비분류</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설비분류명을 작성해주세요." name="category" value={formData.category} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설비명칭</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설비명칭을 작성해주세요." name="name" value={formData.name} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">형식승인번호</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="형식승인번호를 작성해주세요." name="approvalNumber" value={formData.approvalNumber} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설비모델명</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설비모델명을 작성해주세요." name="modelName" value={formData.modelName} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설비일련번호</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설비일련번호를 작성해주세요." name="serialNumber" value={formData.serialNumber} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설비제원</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설비제원을 작성해주세요." name="specifications" value={formData.specifications} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">제조사</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="제조사를 작성해주세요." name="manufacturer" value={formData.manufacturer} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">제조년월</p>
                            <div class="detail_box detail_date_box date-wrap">
                                <div className={`date-input-wrap ${formData.manufactureDate ? "selected" : ""}`} onChange={onChange} required>
                                    <p class="date-title" style={{ display: formData.manufactureDate ? "none" : "block" }}>{formData.manufactureDate || '제조년월 년-월-일'}</p>
                                    <input type="date" class="form-input" id="start_date" name="manufactureDate" value={formData.manufactureDate} />
                                </div>
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">구입일자</p>
                            <div class="detail_box detail_date_box date-wrap">
                                <div className={`date-input-wrap ${formData.purchaseDate ? "selected" : ""}`} onChange={onChange} required>
                                    <p class="date-title" style={{ display: formData.purchaseDate ? "none" : "block" }}>{formData.purchaseDate || '구입일자 년-월-일'}</p>
                                    <input type="date" class="form-input" id="start_date" name="purchaseDate" value={formData.purchaseDate} />
                                </div>
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">구입가격</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="구입가격을 작성해주세요." name="purchasePrice" value={formData.purchasePrice} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">구입업체</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="구입업체을 작성해주세요." name="purchaseCompany" value={formData.purchaseCompany} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">구입연락처</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="구입연락처를 작성해주세요." name="purchaseContact" value={formData.purchaseContact} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">AS연락처</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="AS연락처를 작성해주세요." name="asContact" value={formData.asContact} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설비사진</p>
                            <div class="detail_box detail_btn_box detail_file_box">
                                <div class="black_line_btn">
                                    <label for="file-upload" class="file-upload-btn">+</label>
                                    <input type="file" accept=".png, .jpg, .jpeg" id="file-upload" class="file-upload-input" name="photoImage" onChange={onChange} />
                                </div>
                                {formData.photoImageFile && (
                                    <div class="file-list-wrap">
                                        <div class="file-item">
                                            <p class="file-name">{formData.photoImageFileName}</p>
                                            <i class="x-icon" onClick={handleDeleteImage}></i>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설치일자</p>
                            <div class="detail_box detail_date_box date-wrap">
                                <div className={`date-input-wrap ${formData.installationDate ? "selected" : ""}`} onChange={onChange} required>
                                    <p class="date-title" style={{ display: formData.installationDate ? "none" : "block" }}>{formData.installationDate || '설치일자 년-월-일'}</p>
                                    <input type="date" class="form-input" id="start_date" name="installationDate" value={formData.installationDate} />
                                </div>
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설치층</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설치층을 작성해주세요." name="installationFloor" value={formData.installationFloor} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">상세위치</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="상세위치를 작성해주세요." name="detailedLocation" value={formData.detailedLocation} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설치업체</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설치업체를 작성해주세요." name="installationCompany" value={formData.installationCompany} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">설치연락처</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="설치연락처를 작성해주세요." name="installationContact" value={formData.installationContact} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">운영상태</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="운영상태를 작성해주세요." name="operationalStatus" value={formData.operationalStatus} onChange={onChange} required />
                            </div>
                        </div>

                        <div class="wrap_controll type-start">
                            <button type="submit" class="btn_dark btn_save">저장</button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

const TopBoard = ({ header }) => {
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();
    const location = useLocation();
    const { buildingName } = location.state;

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo"> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="">
                            <img src={logo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">{buildingName}</p>
                </div>
                {header}
                <div className="wrap_right mb">
                    <Link className="btn_page_left" to="/buildingEquipmentStatus_mb.html">
                        <i className="x-icon"></i>
                    </Link>
                </div>
            </div>
        </>
    );
};

const MidColumnBoard = ({ openModal }) => {
    let { id } = useParams();
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    const handleExportExcel = () => {
        apiWrapper(async () => {
            // const { status, data } = await fireonApi.downloadFireFightingFacilityList();
            // if (status === false) {
            //     alert(`엑셀 저장에 실패하였습니다.\n${data}`);
            // }
        });
    }

    return (
        <div className="mid_board mid_col_board">
            <div className="wrap_mid_le">
                <div className="wrap_item_contr">
                    <div className="building_info">
                        <div className="item_info">
                            <p className="txt_info title_info">일련번호</p>
                            <p className="txt_info code_info">{serialNumber}</p>
                        </div>
                        <div className="item_info">
                            <p className="txt_info title_info">DEI 코드</p>
                            <p className="txt_info code_info">{dei}</p>
                        </div>
                    </div>
                </div>
                <div className="wrap_item_contr">
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/new/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        건축물 일반 현황
                    </Link>
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/building-detail-status/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        건축물 상세 현황
                    </Link>
                    <button
                        className="btn_contr btn_new active"
                    >
                        소방설비 등록 현황
                    </button>
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/user-status/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        사용자 등록 현황
                    </Link>
                </div>
            </div>
            <div className="wrap_right">
                <div className="wrap_item_contr">
                    <button className="btn_contr btn_add pc" onClick={handleExportExcel}>엑셀</button>
                    <button className="btn_contr btn_add btn_active_add pc" onClick={() => openModal(null)}>추가</button>
                </div>
            </div>
        </div>
    );
};

const TableBoard = ({ dataSource, openModal, checkedIds, handleCheckAll, handleChangeChecked }) => {
    return (
        <div className="table_board">
            <div className="containerTable fireEquipmentTable">
                <ul className="head_table">
                    <li><input className="all_chk" type="checkbox" onChange={handleCheckAll} /></li>
                    <li><p>관리순번</p></li>
                    <li><p>설비분류</p></li>
                    <li><p>설비명칭</p></li>
                    <li><p>형식승인번호</p></li>
                    <li><p>설비모델명</p></li>
                    <li><p>설비일련번호</p></li>
                    <li><p>설비제원</p></li>
                    <li><p>제조사</p></li>
                    <li><p>제조년월</p></li>
                    <li><p>구입일자</p></li>
                    <li><p>구입가격</p></li>
                    <li><p>구입업체</p></li>
                    <li><p>구입연락처</p></li>
                    <li><p>AS연락처</p></li>
                    <li><p>설비사진</p></li>
                    <li><p>설치일자</p></li>
                    <li><p>설치층</p></li>
                    <li><p>상세위치</p></li>
                    <li><p>설치업체</p></li>
                    <li><p>설치연락처</p></li>
                    <li><p>운영상태</p></li>
                </ul>

                <div className="body_table">
                    <div className="inner_table_wrap">
                        {dataSource &&
                            dataSource.results.map((item, index) => (
                                <div className="wrap_table_item">
                                    <div className="inner_table_item table_item_01">
                                        <input className="cont_table_chekbox" type="checkbox" checked={checkedIds.includes(item.id)} onChange={(e) => handleChangeChecked(e, item.id)} />
                                    </div>
                                    <div className="inner_table_item table_item_02">
                                        <p className="cont_table_item modal-td" onClick={() => openModal(item.id)}>{item.id}</p>
                                    </div>
                                    <div className="inner_table_item table_item_03">
                                        <p className="cont_table_item">{item.category}</p>
                                    </div>
                                    <div className="inner_table_item table_item_04">
                                        <p className="cont_table_item">{item.name}</p>
                                    </div>
                                    <div className="inner_table_item table_item_05">
                                        <p className="cont_table_item">{item.approvalNumber}</p>
                                    </div>
                                    <div className="inner_table_item table_item_06">
                                        <p className="cont_table_item">{item.modelName}</p>
                                    </div>
                                    <div className="inner_table_item table_item_07">
                                        <p className="cont_table_item">{item.serialNumber}</p>
                                    </div>
                                    <div className="inner_table_item table_item_08">
                                        <p className="cont_table_item">{item.specifications}</p>
                                    </div>
                                    <div className="inner_table_item table_item_09">
                                        <p className="cont_table_item">{item.manufacturer}</p>
                                    </div>
                                    <div className="inner_table_item table_item_10">
                                        <p className="cont_table_item">{item.manufactureDate}</p>
                                    </div>
                                    <div className="inner_table_item table_item_11">
                                        <p className="cont_table_item">{item.purchaseDate}</p>
                                    </div>
                                    <div className="inner_table_item table_item_12">
                                        <p className="cont_table_item">{item.purchasePrice}</p>
                                    </div>
                                    <div className="inner_table_item table_item_13">
                                        <p className="cont_table_item">{item.purchaseCompany}</p>
                                    </div>
                                    <div className="inner_table_item table_item_14">
                                        <p className="cont_table_item">{item.purchaseContact}</p>
                                    </div>
                                    <div className="inner_table_item table_item_15">
                                        <p className="cont_table_item">{item.asContact}</p>
                                    </div>
                                    <div className="inner_table_item table_item_16">
                                        <p className="cont_table_item">{item.photoImage === '' ? '무' : '유'}</p>
                                    </div>
                                    <div className="inner_table_item table_item_17">
                                        <p className="cont_table_item">{item.installationDate}</p>
                                    </div>
                                    <div className="inner_table_item table_item_18">
                                        <p className="cont_table_item">{item.installationFloor}</p>
                                    </div>
                                    <div className="inner_table_item table_item_19">
                                        <p className="cont_table_item">{item.detailedLocation}</p>
                                    </div>
                                    <div className="inner_table_item table_item_20">
                                        <p className="cont_table_item">{item.installationCompany}</p>
                                    </div>
                                    <div className="inner_table_item table_item_21">
                                        <p className="cont_table_item">{item.installationContact}</p>
                                    </div>
                                    <div className="inner_table_item table_item_22">
                                        <p className="cont_table_item">{item.operationalStatus}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
            {/* 필요없음
            <div class="wrap_controll type-start type-black">
                <div class="wrap_btn_set">
                    <button class="btn_set btn_cancle">취소</button>
                    <button class="btn_set btn_save">저장</button>
                </div>
                <div id="pagination">
                    <Pagenation />
                </div>
            </div> */}
        </div >
    );
};
